import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SelectCstComponent} from '@core/customer/components/select-cst/select-cst.component';
import {PaginationComponent} from '@core/customer/components/pagination/pagination.component';
import {FormsModule} from '@angular/forms';
import {ConfirmComponent} from '@app/core/customer/modals/confirm/confirm.component';
import {SrCompleteComponent} from '@core/customer/modals/sr-complete/sr-complete.component';
import {PlainModalComponent} from '@core/customer/modals/plain-modal/plain-modal.component';
import {InfoModalComponent} from '@core/customer/modals/info-modal/info-modal.component';


@NgModule({
  declarations: [
      SelectCstComponent,
      PaginationComponent,
      ConfirmComponent,
      SrCompleteComponent,
      PlainModalComponent,
      InfoModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
      SelectCstComponent,
      PaginationComponent,
      ConfirmComponent,
      SrCompleteComponent,
      PlainModalComponent,
      InfoModalComponent,
  ]
})
export class CustomComponentsModule { }
